const { IS_LIVE, REACT_APP_WEBSITE_APP, REACT_APP_BASE_URL, REACT_APP_POS_BASE_URL } = process.env;

const envConfig = {
  isLive: IS_LIVE === 'live' || false,
  websiteAppUrl: REACT_APP_WEBSITE_APP,
  baseUrl: REACT_APP_BASE_URL,
  posUrl: REACT_APP_POS_BASE_URL,
};
export default envConfig;
